module.exports = __webpack_public_path__ + "static/media/documents_003.7b3a600d.svg";